import Image from "next/image";

import { useTranslation } from "@flare/i18n";
import { Button, Heading, Text } from "@flare/ui/components";

export function ConfirmationLssBanner() {
  const { t } = useTranslation();

  return (
    <div className="mt-sp-7 flex flex-col rounded-xl bg-success p-sp-8 md:flex-row">
      <div className="flex flex-col items-center md:items-start">
        <Text className="uppercase text-action" variant="body1-highlight">
          {t("FUNNEL_STEP_CONFIRMATION_LSS_BANNER_STATUS")}
        </Text>
        <Heading
          variant="h1"
          className="mt-sp-4 text-center md:mt-sp-7 md:text-left"
          textWrap="pretty"
        >
          {t("FUNNEL_STEP_CONFIRMATION_LSS_BANNER_TITLE")}
        </Heading>
        <Text className="my-sp-4 mb-sp-8 text-center md:my-sp-6 md:text-left">
          {t("FUNNEL_STEP_CONFIRMATION_LSS_BANNER_SUBTITLE")}
        </Text>
        <Button
          type="submit"
          size="lg"
          className="mt-sp-6 hidden max-w-[66%] justify-center rounded-sm md:flex"
          fullWidth
        >
          {t("FUNNEL_STEP_CONFIRMATION_LSS_BANNER_CTA")}
        </Button>
      </div>
      <div className="flex items-end justify-end md:min-w-[50%]">
        <Image
          src="/next/images/funnel/lss-desk.png"
          alt={t("FUNNEL_STEP_CONFIRMATION_LSS_BANNER_IMG_ALT")}
          width={284}
          height={166}
        />
      </div>
      <Button
        type="submit"
        size="lg"
        className="mt-sp-8 flex justify-center rounded-sm md:hidden"
        fullWidth
      >
        {t("FUNNEL_STEP_CONFIRMATION_LSS_BANNER_CTA")}
      </Button>
    </div>
  );
}
